import { useEffect } from 'react';

const SITE_URL = 'https://toftejendomme.dk';
const DEFAULT_OG_IMAGE = `${SITE_URL}/android-chrome-512x512.png`;

interface SeoOptions {
  title: string;
  description: string;
  path: string;
  ogType?: 'website' | 'article';
  noIndex?: boolean;
}

const setMetaByName = (name: string, content: string) => {
  let tag = document.head.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

const setMetaByProperty = (property: string, content: string) => {
  let tag = document.head.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

const setCanonical = (href: string) => {
  let link = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

const useSeo = ({ title, description, path, ogType = 'website', noIndex = false }: SeoOptions) => {
  useEffect(() => {
    const absoluteUrl = `${SITE_URL}${path}`;

    document.title = title;
    setCanonical(absoluteUrl);
    setMetaByName('description', description);
    setMetaByName('robots', noIndex ? 'noindex, nofollow' : 'index, follow');
    setMetaByName('twitter:card', 'summary_large_image');
    setMetaByName('twitter:title', title);
    setMetaByName('twitter:description', description);
    setMetaByName('twitter:image', DEFAULT_OG_IMAGE);

    setMetaByProperty('og:type', ogType);
    setMetaByProperty('og:site_name', 'Toft Ejendomme');
    setMetaByProperty('og:title', title);
    setMetaByProperty('og:description', description);
    setMetaByProperty('og:url', absoluteUrl);
    setMetaByProperty('og:image', DEFAULT_OG_IMAGE);
  }, [description, noIndex, ogType, path, title]);
};

export default useSeo;
